var map = {
	"./alasanmeng.json": "0d6f",
	"./baoding.json": "8bb9",
	"./beijing.json": "5de1",
	"./changsha.json": "7ae6",
	"./chengdu.json": "74ce",
	"./chongqing.json": "e50db",
	"./foshan.json": "74e7",
	"./fuzhou.json": "343d",
	"./guangzhou.json": "912e",
	"./guiyang.json": "6bf3",
	"./hangzhou.json": "17a3",
	"./huizhou.json": "e016",
	"./jinan.json": "6ec7",
	"./linyi.json": "29e4",
	"./nanchang.json": "7d42",
	"./ningbo.json": "485b",
	"./putian.json": "3b81",
	"./quanzhou.json": "6a64",
	"./shanghai.json": "54fd",
	"./shenzhen.json": "e64c",
	"./suzhou.json": "2061",
	"./wenzhou.json": "d38c",
	"./wuhan.json": "0fa1",
	"./xiamen.json": "80f7",
	"./zhangzhou.json": "ccf7",
	"./zhengzhou.json": "62c8",
	"./zhoushan.json": "3b91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2615";